<div class="chat-header">
  <div id="botinput-wrapper">
    <p class="disclaimer">
      <label [ngClass]="{ hidemobileView: showDisclaimer }">
        Disclaimer: The information provided from this tool is not for legal
        advice, and is intended to provide references in regards to state
        laws.</label
      >
      <span class="expan-down-arrow mobileViewBtn">
        @if (showDisclaimer) {
        <a data-tooltip="Show Disclaimer" (click)="toggleDisclaimer()">
          <i class="fa fa-angle-double-down"></i>
        </a>
        } @if (!showDisclaimer) {
        <a data-tooltip="hide Disclaimer" (click)="toggleDisclaimer()">
          <i class="fa fa-angle-double-up"></i>
        </a>
        }
      </span>
    </p>
  </div>

  <div id="chat-message-enter-box">
    <div id="chatForm">
      <app-autocomplete
        (setautoComplete)="setautoComplete($event)"
        [autoSearchDafaultValue]="autoSearchDafaultValue"
        [suggestionList]="suggestionList"
        [defaultSelectLanguage]="language"
      ></app-autocomplete>
    </div>
  </div>
</div>
